import { ChangeDetectorRef, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
  FormFieldComponent,
  InputComponent,
  LabelComponent,
} from '@core/user-interface-legacy';

type HtmlClassDialogData = {
  initial: string;
};

type HtmlClassDialogResult = string | undefined;

@Component({
  selector: 'rt-html-class-dialog',
  templateUrl: './html-class-dialog.component.html',
  imports: [
    DialogHeaderComponent,
    TranslatePipe,
    DialogBodyComponent,
    DialogFooterComponent,
    ButtonComponent,
    FormFieldComponent,
    InputComponent,
    ReactiveFormsModule,
    LabelComponent,
  ],
})
export class HtmlClassDialogComponent
  implements DialogComponentI<HtmlClassDialogData, HtmlClassDialogResult>
{
  private readonly dialogRef = inject(DialogRef);
  private readonly destroyRef = inject(DestroyRef);
  private readonly cdRef = inject(ChangeDetectorRef);
  public readonly form = inject(NonNullableFormBuilder).control('');

  public ngOnInit() {
    this.form.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.cdRef.detectChanges());
  }

  public setDialogData(data: HtmlClassDialogData): void {
    this.form.setValue(data.initial);
  }

  public apply() {
    this.dialogRef.close(this.form.value);
  }

  public cancel() {
    this.dialogRef.close();
  }
}
